import * as types from './action-types';

import ReportsApi from '../../api/ReportsApi';

import { getSelectedFields, formatSelectedFields } from './helper';

import {
  translateReportFilters,
  translateSelectedFilters,
  formatFilters,
  formatFiltersForAPI
} from './report-edit/filters';

import { translateSchedule, formatSchedule } from './report-edit/schedule';
import ChipInput from '../../components/filter/filters/chip-input/ChipInput';
import _ from 'lodash';
import CostcentreApi from '../../api/CostcentreApi';
import { translateRecipients } from './report-edit/recipients';

// fetch Reports
export const fetchReports = fetchParams => ({
  type: types.FETCH_REPORTS,
  payload: ReportsApi.getReports(fetchParams)
});

//Report Fields

export const fetchReportFieldsSuccess = data => ({
  type: types.FETCH_REPORT_FIELDS_SUCCESS,
  data
});

export const fetchReportFields = (id, category) => {
  return dispatch => {
    return dispatch({
      type: types.FETCH_REPORT_FIELDS,
      payload: ReportsApi.getReportFields(id, category).then(({ data }) => {
        const repFilters = translateReportFilters(data.filters);

        const fetchPromises = [
          dispatch(setSchedule(translateSchedule(data.schedule))),
          dispatch(setRecipients(translateRecipients(data.schedule))),
          dispatch(setReportFilters(repFilters)),
          dispatch(
            setFilters(
              translateSelectedFilters(data.SelectedFilters, repFilters)
            )
          ),
          dispatch(fetchReportFieldsSuccess(data)),
          dispatch(setSelectedFields(getSelectedFields(data.fields)))
        ];

        if( category === 'user')
          fetchPromises.splice(0, 0, dispatch(resetRestriction(data.restrictions)));

        Promise.all(fetchPromises);
      })
    });
  };
};

export const setSelectedFields = data => ({
  type: types.SET_SELECTED_FIELDS,
  data
});

export const setBusinessReport = data => ({
  type: types.SET_BUSINESS_REPORT,
  data
});

export const setUserReport = data => ({
  type: types.SET_USER_REPORT,
  data
});

export const setFilters = data => ({
  type: types.SET_FILTERS,
  data
});

export const setReportFilters = data => ({
  type: types.SET_REPORT_FILTERS,
  data
});

export const setSchedule = data => ({
  type: types.SET_SCHEDULE,
  data
});

export const setRecipients = data => ({
  type: types.SET_RECIPIENTS,
  data
});

export const setDetails = data => ({
  type: types.SET_DETAILS,
  data
});

export const setCountry = data => ({
  type: types.SET_COUNTRY,
  data
});

// export const setCostcenter = data => ({
//   type: types.SET_COSTCENTER,
//   data
// });
//
const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export const resetRestriction = (data = []) => {
  let mappedData = [];
  if(data){
    mappedData = data.map(filter => {
      const tempFilter = {};
      tempFilter.title = filter.typeName;
      tempFilter.typeId = filter.typeId;
      tempFilter.source = filter.options;
      tempFilter.component = ChipInput;
      tempFilter.value = filter.values || [];
      return tempFilter;
    });
  }


  return {
    type: types.RESET_RESTRICTIONS,
    data: mappedData
  };
};

export const fetchRestriction = (country, costcenter) => {
  return dispatch => {
    return CostcentreApi.getCompanyRestrictionFilters(
      country.value,
      costcenter.value
    ).then(res => {
      dispatch(resetRestriction(res));
    });
  };
};

export const setCostcenter = data => {
  return {
    type: types.SET_COSTCENTER,
    data
  };
};

export const setDynamicFilters = data => {
  const payload = {
    type: types.SET_RESTRICTIONS,
    data
  };
  return payload;
};

// Export report
export const exportReport = (
  {
    id,
    category,
    companyCode,
    countryCode,
    title,
    businessReportId,
    legacyReportConfiguration,
    restrictions
  },
  getExportCallback
) => ({
  type: types.EXPORT_REPORT,
  payload: ReportsApi.exportReport(
    {
      id,
      category,
      companyCode,
      countryCode,
      title,
      businessReportId,
      legacyReportConfiguration,
      restrictions
    },
    getExportCallback
  )
});

// Export customised report

// const exportingCustomisedReport = () => ({
//   type: types.EXPORTING_CUSTOMISED_REPORT
// });

// Change schedule
export const changeSchedule = () => ({
  type: types.CHANGE_SCHEDULE
});

// const exportCustomisedReportSuccess = () => ({
//   type: types.EXPORT_CUSTOMISED_REPORT_SUCCESS
// });
//
// const exportCustomisedReportFailed = () => ({
//   type: types.EXPORT_CUSTOMISED_REPORT_FAILED
// });

export const customisedExportReport = report => {
  const {
    reportId,
    reportCategory,
    businessReportId,
    reportName,
    selectedFields,
    filters,
    costcenter,
    country
  } = report;

  const params = {
    id: reportId,
    category: reportCategory,
    companyCode: costcenter.value,
    countryCode: country.value,
    fields: formatSelectedFields(selectedFields),
    title: reportName,
    filters: formatFilters(filters),
    businessReportId
  };

  return dispatch => {
    return dispatch({
      type: types.EXPORT_CUSTOMISED_REPORT,
      payload: ReportsApi.customisedExportReport(params)
    });
  };
};

// Save Report / Update Report
export const reportAction = (type, report) => {
  console.log(type);
  console.log(report);

  const {
    reportId,
    reportCategory,
    businessReportId,
    reportName,
    reportDescription,
    selectedFields,
    filters,
    schedule,
    recipients,
    costcenter,
    country,
    isScheduleUpdated,
    dynamicFilters
  } = report;

  const transFilters = formatFiltersForAPI(filters);

  const transformRestrictionsPayload = payload => {
    // {"typeId":"2","values":["Achmea","Sales"]}
    return payload.map(data => {
      const res = {};
      res.typeId = data.typeId;
      res.typeName = data.title;
      res.values = data.value.map(d => d.value);
      return res;
    });
  };

  const params = {
    id: reportId,
    category: reportCategory,
    businessReportId,
    reportName,
    reportDescription,
    fields: formatSelectedFields(selectedFields),
    filters: transFilters,
    schedule: formatSchedule(schedule, recipients),
    isScheduleUpdated,
    companyCode: costcenter.value,
    countryCode: country.value,
    restrictions: transformRestrictionsPayload(dynamicFilters)
  };

  const apiPromise =
    type === 'create'
      ? ReportsApi.createReport(params)
      : ReportsApi.updateReport(params);

  return dispatch => {
    return dispatch({
      type: types.SAVE_REPORT,
      payload: apiPromise
    });
  };
};

export const cloneReport = params => {
  const { id, title, description } = params;

  const postData = {
    id,
    Name: title,
    Description: description
  };

  return dispatch => {
    return dispatch({
      type: types.CLONE_REPORT,
      payload: ReportsApi.cloneReport(postData)
    });
  };
};

// DELETE report
export const deleteReport = reportId => ({
  type: types.DELETE_REPORT,
  payload: ReportsApi.deleteReport(reportId).then(data => {
    if (!data.success) {
      throw data.error.errorMessage;
    }
    return data;
  })
});



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/actions.js